import { render, staticRenderFns } from "./AssistantHeader.vue?vue&type=template&id=4427ead3&scoped=true"
import script from "./AssistantHeader.vue?vue&type=script&lang=ts"
export * from "./AssistantHeader.vue?vue&type=script&lang=ts"
import style0 from "./AssistantHeader.vue?vue&type=style&index=0&id=4427ead3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4427ead3",
  null
  
)

export default component.exports